import { render, staticRenderFns } from "./message-scrolling.vue?vue&type=template&id=fa7626ac&scoped=true"
import script from "./message-scrolling.vue?vue&type=script&lang=js"
export * from "./message-scrolling.vue?vue&type=script&lang=js"
import style0 from "./message-scrolling.vue?vue&type=style&index=0&id=fa7626ac&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7626ac",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/components/message-scrolling.vue
// module id = null
// module chunks = 